(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('ChangeAvatarController', ChangeAvatarController);

    ChangeAvatarController.$inject = ['User', '$mdDialog', '$scope', '_', 'user'];

    /* @ngInject */
    function ChangeAvatarController(User, $mdDialog, $scope, _, user) {
        var vm = this;
        vm.model = {
            isLoading: false,
            user: '',
            loadedImage: '',
            croppedImage: ''
        };
        vm.fileSubmitted = fileSubmitted;
        vm.cancelDialog = cancelDialog;
        vm.hideDialog = hideDialog;

        activate();

        ////////////////

        function activate() {
            vm.model.user = user;
            vm.model.loadedImage = _.get(user, 'avatar', '');
        }

        function fileSubmitted(flow) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                $scope.$apply(function () {
                    if(!(flow.files[0].file.type == 'image/jpeg' || flow.files[0].file.type == 'image/png')) {
                        alert('Недопустимый тип файла!'+'Достпуна загрузка изображений в формате JPEG и PNG');
                        vm.model.loadedImage = '';
                        vm.model.croppedImage = '';
                        flow.files = [];
                        return;
                    }
                    if(flow.files[0].file.size >  9*1024*1024) {
                        alert('Недопустимый размер файла!'+'Достпуна загрузка изображений размером не более 9 MB');
                        vm.model.loadedImage = '';
                        vm.model.croppedImage = '';
                        flow.files = [];
                        return;
                    }
                    vm.model.loadedImage = event.target.result;
                    flow.files = [];
                });
            };
            fileReader.readAsDataURL(flow.files[0].file);
        }

        function hideDialog() {
            //if(vm.model.isLoading) {
            //    alert('Данные уже обновляются!');
            //    return;
            //}

        //    vm.model.user.avatar = vm.model.croppedImage;
            $mdDialog.hide(vm.model.croppedImage);
           /* vm.model.isLoading = true;
            if(isCreateNew) {
                User.save(vm.model.user, function (response) {
                    vm.model.isLoading = false;
                    $mdDialog.hide(vm.model.user.avatar);
                    $state.go('profile', {userId: response.id}, {inherit: false});

                }, function () {
                    vm.model.isLoading = false;
                });
            } else {
                User.update(vm.model.user, function () {
                    vm.model.isLoading = false;
                    $mdDialog.hide(vm.model.user.avatar);
                }, function () {
                    vm.model.isLoading = false;
                });
            }*/
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }
    }

})();

